import { AfterViewInit, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { DdvDate } from '@ddv/models';
import { ModalDirective, ModalOptions } from '@hs/ui-core-layout';
import { IconComponent } from '@hs/ui-core-presentation';

import { DashboardExportFormComponent, ExcelExportChoices } from './dashboard-export-form/dashboard-export-form.component';
import { DashboardPDFExportService } from '../../services/dashboard-pdf-export';

@Component({
    selector: 'ddv-dashboard-export',
    templateUrl: './dashboard-export.component.html',
    styleUrls: ['./dashboard-export.component.scss'],
    imports: [
        IconComponent,
        DashboardExportFormComponent,
        ModalDirective,
    ],
})
export class DashboardExportComponent implements AfterViewInit {
    @Input() clientCode: string | undefined;
    @Input() dashboard: { name?: string, id?: string | number } | undefined;
    @Input() widgets: { name?: string, id?: string | number }[] | undefined;
    @Input() hasCrosstalkData = false;

    @ViewChild('anchor', { static: false, read: ElementRef }) private readonly iconRef: ElementRef<HTMLElement> | undefined;

    private readonly pdfExportService = inject(DashboardPDFExportService);

    protected showModal = false;
    protected modalOptions: ModalOptions = {};

    ngAfterViewInit(): void {
        this.modalOptions = {
            anchorToElement: this.iconRef?.nativeElement,
            position: 'bottom-right',
        };
    }

    protected async exportToPDF(): Promise<void> {
        this.showModal = false;
        await this.pdfExportService.exportDashboardToPDF(`${this.dashboard?.name}_${DdvDate.today.toDDMMYYYYFormat()}`);
    }

    protected exportToExcel(_choices: ExcelExportChoices): void {
        throw new Error('not yet implemented');
    }
}
